// extracted by mini-css-extract-plugin
module.exports = {"container_tab":"tab_container_tab__NBz0X","item_tab":"tab_item_tab__354_c","active_tab":"tab_active_tab__1o6sq","inner_tab":"tab_inner_tab__30sNu","sticky":"tab_sticky__34qcw"};